import { render, staticRenderFns } from "./YarnType.vue?vue&type=template&id=297da984&scoped=true&"
import script from "./YarnType.vue?vue&type=script&lang=js&"
export * from "./YarnType.vue?vue&type=script&lang=js&"
import style0 from "./YarnType.vue?vue&type=style&index=0&id=297da984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297da984",
  null
  
)

export default component.exports